import React, { Component } from 'react'
import { connect } from 'react-redux'

import ahcLoginRedirect from '../../../../utilities/profile/accor/ahcLoginRedirect'
import formatPrice from '../../../../utilities/currency/formatPrice'
import renderHTML from 'react-render-html'

import yn from 'yn'
import _ from 'lodash'

import tarsLoyaltyIcon from '../../../../assets/icons/tars-loyalty-icon.svg'

if (process.env.REACT_APP_COMPONENT_ROOM_RATE_STAGE_BUTTON_LAYOUT ==='columns') {
	require('../../../../styles/css/components/room/layouts/bk-flow-room-rate-price-button-columns.css')
}

class BkFlowRoomCardRateStagePriceButtonColumns extends Component {
	render() {
		const {
			activeStep,
			availabilityData,
			configData,
			currentQueryData,
			currentUpSells,
			displayedPriceFrequency,
			enhancementData,
			isLoyaltyRate,
			isMembersRate,
			isProfileAuthenticated,
			multiRoomData,
			partnerRateData,
			rateCurrencyCode,
			rateCurrencySymbol,
			rateDestinationFeeAmount,
			rateDestinationFeeCurrencyCode,
			rateDestinationFeeCurrencySymbol,
			rateDestinationFeeFrequency,
			rateDestinationFeeLabel,
			rateDetailsExpanded,
			rateFeesTotal,
			ratePlanCancelPolicy,
			ratePlanDescription,
			ratePlanName,
			rateTaxesFeesTotal,
			rateTaxesTotal,
			roomGroup,
			roomRateData,
			roomRateDetailsData,
			roomRatePrice,
			toggleActiveRoom,
			toggleRateDetails,
			upSellsToggleEvent,
			urlData,
		} = this.props

		const hotelLabels = configData.hotel.labels[0]

		return (
			<div className="bk-flow-room__price-content columns">
				<div className="bk-flow-room__price-details">
					{ ratePlanName &&
						<h5 className="bk-flow-room__price-title">
							{ yn(process.env.REACT_APP_COMPONENT_PARTNERS_RATE_BRANDING) &&
								partnerRateData &&
								partnerRateData.logos &&
								partnerRateData.logos.dark &&
								<span
									className="bk-flow-room__price-title-partner-brand"
									onClick={() => toggleRateDetails()}
									tabIndex={0}
								>
									{renderHTML(partnerRateData.logos.dark)}
								</span>
							}

							{isLoyaltyRate &&
								<div className="bk-flow-room__price-details-icon">
									<img src={tarsLoyaltyIcon} alt="Loyalty Member Rate"/>
									<p className="label u-remove-margin">{ hotelLabels.yourRate ? hotelLabels.yourRate : 'Your Rate' }</p>
								</div>
							}

							{ isMembersRate &&
								<p className="bk-flow-room__price-details-members-label u-remove-margin">
									{ hotelLabels && hotelLabels.membersRate ? hotelLabels.membersRate : 'Members Rate' }
								</p>
							}

							{ratePlanName}
						</h5>
					}

					{ ratePlanDescription &&
						<div className="bk-flow-room__price-details-rate-description">
							<p>{ratePlanDescription}</p>
						</div>
					}

					<div className="bk-flow-room__price-details-list">
						{ ratePlanCancelPolicy && <p className="cancel-deadline">{ ratePlanCancelPolicy }</p> }
					</div>
				</div>

				<div className="bk-flow-room__price-values">
					<p className="bk-flow-room__price-details-rate u-remove-margin">
						<span className="currency-symbol">{rateCurrencySymbol}</span>
						{formatPrice(roomRatePrice, 2)}
						{ yn(process.env.REACT_APP_COMPONENT_ROOM_CURRENCY_CODES) && rateCurrencyCode &&
							<span className="currency-code">{rateCurrencyCode}</span>
						}

						<span className="bk-flow-room__price-details-rate-frequency u-remove-margin">
							{ displayedPriceFrequency === 'per stay' ?
								hotelLabels && hotelLabels.total ? hotelLabels.total : 'Total'
								:
								hotelLabels && hotelLabels.perNight ? hotelLabels.perNight : 'Per Night'
							}
						</span>
					</p>

					{ yn(process.env.REACT_APP_COMPONENT_ENABLE_RATE_COMBINED_TAXES_FEES) &&
						rateTaxesFeesTotal > 0 ?
						<p className="bk-flow-room__price-details-taxes">
							({ hotelLabels.plus ? hotelLabels.plus : 'Plus' } {rateCurrencySymbol}{formatPrice(rateTaxesFeesTotal.toFixed(2), 2)} {rateCurrencyCode} {hotelLabels.taxesAndFees ? hotelLabels.taxesAndFees : 'Taxes & Fees'} {rateDestinationFeeAmount && rateDestinationFeeLabel && ' of which ' + rateDestinationFeeCurrencySymbol + formatPrice(rateDestinationFeeAmount, 2) + ' ' + rateDestinationFeeCurrencyCode + ' ' + rateDestinationFeeFrequency + ' is a ' + rateDestinationFeeLabel})
						</p>
					: rateTaxesTotal > 0 ?
						<p className="bk-flow-room__price-details-taxes">
							({ hotelLabels.plus ? hotelLabels.plus : 'Plus' } {rateCurrencySymbol}{formatPrice(rateTaxesTotal, 2)} {rateCurrencyCode} {hotelLabels.taxes}{rateFeesTotal > 0 && (' & ' + rateCurrencySymbol + formatPrice(rateFeesTotal, 2) + ' ' + rateCurrencyCode + ' ' + hotelLabels.fees)}{rateDestinationFeeAmount && rateDestinationFeeLabel && ' of which ' + rateDestinationFeeCurrencySymbol + formatPrice(rateDestinationFeeAmount, 2) + ' ' + rateDestinationFeeCurrencyCode + ' ' + rateDestinationFeeFrequency + ' is a ' + rateDestinationFeeLabel})
						</p>
					:
						null
					}

					<button
						onClick={() => toggleRateDetails()}
						className="bk-flow-room__price-details-button btn btn-text"
					>
						{ hotelLabels && hotelLabels.roomRateDetails ? hotelLabels.roomRateDetails : 'Details'}
						<i>{ rateDetailsExpanded ? ' -' : ' +' }</i>
					</button>
				</div>

				<div className="bk-flow-room__price-buttons">
					{ !_.isEmpty(currentUpSells) ?
						<button
							className="btn btn-transparent"
							onClick={() => upSellsToggleEvent(roomRateData.roomTypeCode, roomRateData.ratePlanCode)}
						>
							{ hotelLabels && hotelLabels.selectRoom ? hotelLabels.selectRoom : 'Book Room '}
						</button>
					: isMembersRate &&
					!isProfileAuthenticated ?
						<button
							className="btn btn-transparent"
							onClick={() => ahcLoginRedirect(currentQueryData)}
						>
							{ hotelLabels && hotelLabels.claimRate ? hotelLabels.claimRate : 'Claim Rate'}
						</button>
					:
						<button
							className="bk-flow-room__price-button btn btn-primary"
							onClick={
								() => toggleActiveRoom(
									availabilityData,
									roomRateData.roomTypeCode,
									roomRateData.ratePlanCode,
									roomGroup,
									activeStep,
									multiRoomData,
									configData,
									urlData,
									enhancementData,
									roomRateDetailsData
								)
							}
						>
							{ hotelLabels && hotelLabels.selectRate ? hotelLabels.selectRate : 'Select Rate' }
						</button>
					}
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		activeStep: state.activeStepData.activeStep,
		availabilityData: state.availabilityData.availability,
		configData: state.configData.configuration,
		currentQueryData: state.availabilityData.currentQuery,
		enhancementData: state.enhancementData,
		isProfileAuthenticated: state.profileData.isProfileAuthenticated,
		multiRoomData: state.multiRoomData,
		roomRateDetailsData: state.roomRateDetailsData,
		urlData: state.availabilityData.urlData,
	}
}

export default connect(mapStateToProps, null)(BkFlowRoomCardRateStagePriceButtonColumns)


// WEBPACK FOOTER //
// ./src/components/room/elements/multi-stage/BkFlowRoomCardRateStagePriceButtonColumns.js